import { useState } from 'react';

const Projects = () => {
  const [previewImage, setPreviewImage] = useState(null);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [currentProjectIndex, setCurrentProjectIndex] = useState(0);
  const projects = [
    {
      name: 'Trulixx Fashion',
      company: 'Phiyorbyte Ltd',
      description: 'A comprehensive e-commerce platform featuring a public-facing storefront and a robust administrative dashboard. The dashboard provides extensive tools to manage product catalogs, process orders, moderate reviews, and analyze financial data through real-time visualizations. The platform is secured with Two-Factor Authentication (2FA) and optimized for efficient data caching.',
      tech: ['React', 'Tailwind CSS', 'React Query', 'Recharts', 'Axios'],
      year: '2026',
      images: [
        '/files/trulixx/trulixx1.png',
        '/files/trulixx/trulixx2.png',
        '/files/trulixx/trulixx3.png',
        '/files/trulixx/dashboard1.png',
        '/files/trulixx/dashboard2.png',
        '/files/trulixx/dashboard3.png'
      ],
      link: 'https://trulixx.com',
      linkStatus: 'live',
    },
    {
      name: 'Project Prose',
      company: 'ProjectProse',
      description: 'A custom-built booking platform and administrative dashboard for a UK-based property management company. It features a public-facing booking engine for premium accommodations and a comprehensive internal dashboard for managing property portfolios and customer reservations.',
      tech: ['React', 'Tailwind CSS', 'React Query', 'Axios', 'AOS'],
      year: '2025',
      images: [
        '/files/projectprose/prose1.png',
        '/files/projectprose/prose2.png',
        '/files/projectprose/prose3.png',
        '/files/projectprose/pdash1.png',
        '/files/projectprose/pdash2.png',
        '/files/projectprose/pdash3.png'
      ],
      link: 'https://project-prose.com',
      linkStatus: 'live',
    },
    {
      name: 'DexterPro Technology',
      company: 'DexterPro Technology',
      description: 'A corporate website for a technology company. It serves as a digital storefront to showcase their services, including custom software development, web applications, and enterprise systems.',
      tech: ['React', 'Tailwind CSS', 'JavaScript'],
      year: '2024',
      images: [
        '/files/dexterpro/dexter1.png',
        '/files/dexterpro/dexter2.png',
        '/files/dexterpro/dexter3.png'
      ],
      link: 'https://dexterprotechnology.com',
      linkStatus: 'live',
    },
  ];

  const passionProjects = [
    {
      name: 'Choir Index',
      company: 'Personal Project',
      description: 'A mobile-first Progressive Web App (PWA) serving as a centralized digital songbook for choir members. It features role-based access, allowing administrators to manage the song database and access codes, while choristers can search, filter, and instantly access lyrics, audio recordings, and sheet music. The platform is optimized for mobile browsers and can be installed directly to the home screen for a native app experience.',
      tech: ['React', 'Tailwind CSS', 'Supabase', 'React Query'],
      year: '2026',
      images: [
        '/files/choirIndex/C1.png',
        '/files/choirIndex/C2.png',
        '/files/choirIndex/C3.png',
        '/files/choirIndex/C4.png',
        '/files/choirIndex/C5.png',
        '/files/choirIndex/C7.png',
        '/files/choirIndex/C8.png',
        '/files/choirIndex/C9.png',
        '/files/choirIndex/C10.png',
        '/files/choirIndex/C11.png',
        '/files/choirIndex/C12.png'
      ],
      link: '',
      linkStatus: 'private',
    },
    {
      name: '9log',
      company: 'Personal Project',
      description: 'A full-stack personal blog featuring a minimalist public interface and a secure private admin dashboard. It provides complete content control, including drafting articles via a Markdown editor, managing media assets for an inspiration gallery, and dynamic SEO handling. The entire platform is optimized for fast, cached data fetching to ensure a seamless reading experience.',
      tech: ['React', 'Tailwind CSS', 'Supabase', 'React Query', 'React Markdown'],
      year: '2026',
      images: [
        '/files/9log/9log1.png',
        '/files/9log/9log2.png',
        '/files/9log/9log3.png'
       ],
      link: 'https://9log.vercel.app',
      linkStatus: 'live',

    },
    /*
    {
      name: 'SportyBet Analytics Dashboard',
      company: 'Personal Project',
      description: 'Betting analytics dashboard transforming history into actionable insights. Upload JSON files to visualize performance metrics, win/loss patterns, and ROI trends with 100% client-side data privacy.',
      tech: ['React', 'Tailwind CSS'],
      year: '2026',
      images: [
        '/files/sporty/sporty1.png',
        '/files/sporty/sporty2.png',
        '/files/sporty/sporty3.png'
      ],
      link: 'https://sporty-dashboard.vercel.app',
      linkStatus: 'live',
    }, */
    {
      name: 'TypeForge',
      company: 'TypeForge',
      description: 'A web-based typography creation application that empowers users to design custom fonts directly in the browser. It features a robust digital editor for drawing vector glyphs on an interactive canvas, alongside a paper scanner mode to extract hand-drawn characters from physical templates. Designs can be tested in a built-in preview environment and instantly compiled into fully functional OpenType font files.',
      tech: ['React', 'Tailwind CSS', 'OpenType.js'],
      year: '2026',
      images: [
        '/files/typeforge/type1.png',
        '/files/typeforge/type2.png',
        '/files/typeforge/type3.png',
        '/files/typeforge/type4.png',
        '/files/typeforge/type5.png',
        '/files/typeforge/type6.png'
      ],
      link: 'https://typeforge-v1.vercel.app',
      linkStatus: 'live',
    },
    {
      name: 'Design Portfolio',
      company: 'Tobi Idowu',
      description: 'A custom portfolio website paired with a built-in Content Management System (CMS). The platform consists of a public-facing website to display work and a private admin dashboard to manage the site\'s content. It features seamless page transitions, secure authentication, and a rich-text editor for drafting case studies.',
      tech: ['React', 'Tailwind CSS', 'Framer Motion', 'Supabase', 'TipTap',],
      year: '2026',
      images: [
        '/files/designPortfolio/t1.png',
        '/files/designPortfolio/t2.png',
        '/files/designPortfolio/t3.png',
        '/files/designPortfolio/t4.png',
        '/files/designPortfolio/t5.png',
        '/files/designPortfolio/t6.png',
        '/files/designPortfolio/t7.png',
        '/files/designPortfolio/t8.png'
      ],
      link: 'https://tobi-idowu.vercel.app',
      linkStatus: 'live',
    },
  ];

  const allProjects = [...projects, ...passionProjects];

  const openImagePreview = (image, projectIndex, imageIndex) => {
    if (!image.includes('Coming Soon')) {
      setPreviewImage({
        src: image,
        alt: `Project screenshot ${imageIndex + 1}`
      });
      setCurrentImageIndex(imageIndex);
      setCurrentProjectIndex(projectIndex);
      setIsPreviewOpen(true);
    }
  };

  const closeImagePreview = () => {
    setIsPreviewOpen(false);
    setPreviewImage(null);
  };

  const nextImage = () => {
    const currentProject = allProjects[currentProjectIndex];
    const nextIndex = (currentImageIndex + 1) % currentProject.images.length;
    setCurrentImageIndex(nextIndex);
    setPreviewImage({
      src: currentProject.images[nextIndex],
      alt: `Project screenshot ${nextIndex + 1}`
    });
  };

  const prevImage = () => {
    const currentProject = allProjects[currentProjectIndex];
    const prevIndex = (currentImageIndex - 1 + currentProject.images.length) % currentProject.images.length;
    setCurrentImageIndex(prevIndex);
    setPreviewImage({
      src: currentProject.images[prevIndex],
      alt: `Project screenshot ${prevIndex + 1}`
    });
  };

  const handlePreviewKeyDown = (e) => {
    if (e.key === 'Escape') {
      closeImagePreview();
    } else if (e.key === 'ArrowLeft') {
      prevImage();
    } else if (e.key === 'ArrowRight') {
      nextImage();
    }
  };

  return (
    <section id="projects" className="min-h-[100svh] sm:min-h-0 py-10 sm:py-20 px-4 bg-white dark:bg-black transition-colors duration-300">
      <div className="max-w-6xl mx-auto w-full">
        {/* Section Title */}
        <div className="mb-12 sm:mb-20 text-center" data-aos="fade-up">
          <h2 className="text-2xl sm:text-3xl font-bold text-black dark:text-white mb-4 transition-colors duration-300">
            Selected Projects
          </h2>
          <div className="w-12 sm:w-16 h-1 bg-black dark:bg-white mx-auto transition-colors duration-300"></div>
        </div>

        {/* Projects List */}
        <div className="flex flex-col border-b border-slate-200 dark:border-white/10 transition-colors duration-300">
          {allProjects.map((project, projectIndex) => (
            <div key={projectIndex} className="py-10 sm:py-16 border-t border-slate-200 dark:border-white/10 flex flex-col md:flex-row gap-6 md:gap-16 group transition-colors duration-300" data-aos="fade-up">
              <div className="md:w-1/3 shrink-0">
                <div className="flex items-center gap-3 mb-4">
                  <h3 className="text-xl sm:text-2xl font-bold text-black dark:text-white transition-colors duration-300">{project.name}</h3>
                  {project.tag === 'Ongoing' && (
                    <span className="px-2 py-0.5 bg-black dark:bg-white text-white dark:text-black text-[10px] font-bold tracking-widest uppercase transition-colors duration-300">
                      Ongoing
                    </span>
                  )}
                </div>
                <div className="flex flex-wrap gap-2">
                  {project.tech.map((tech, techIndex) => (
                    <span key={techIndex} className="text-xs font-semibold px-2.5 py-1 bg-slate-50 dark:bg-white/5 text-slate-700 dark:text-gray-300 border border-slate-200 dark:border-white/10 transition-colors duration-300">
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
              <div className="md:w-2/3 flex flex-col justify-start">
                <p className="text-slate-600 dark:text-gray-300 text-sm sm:text-base leading-relaxed mb-8 max-w-2xl transition-colors duration-300">
                  {project.description}
                </p>
                <div className="flex items-center gap-6 mt-auto">
                  {project.linkStatus === 'live' && project.link ? (
                    <a href={project.link} target="_blank" rel="noopener noreferrer" className="text-sm font-bold text-black dark:text-white hover:opacity-60 transition-opacity flex items-center gap-1 border-b-2 border-black dark:border-white pb-0.5">
                      View Site
                    </a>
                  ) : (
                    <span className="text-sm font-bold text-slate-400 dark:text-gray-600 flex items-center gap-1 cursor-not-allowed border-b-2 border-slate-200 dark:border-white/10 pb-0.5 transition-colors duration-300">
                      Private Repository
                    </span>
                  )}
                  {project.images && project.images[0] && !project.images[0].includes('Coming Soon') && (
                    <button 
                      onClick={() => openImagePreview(project.images[0], projectIndex, 0)}
                      className="text-sm font-bold text-slate-500 dark:text-gray-400 hover:text-black dark:hover:text-white transition-colors"
                    >
                      View Gallery ({project.images.length})
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Image Preview Modal */}
      {isPreviewOpen && previewImage && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-95 z-50 flex items-center justify-center p-4"
          onClick={closeImagePreview}
          onKeyDown={handlePreviewKeyDown}
          tabIndex={0}
        >
          <div className="relative max-w-6xl max-h-[90vh] flex flex-col w-full">
            {/* Close Button */}
            <button
              onClick={closeImagePreview}
              className="absolute top-0 right-0 z-10 p-2 text-white hover:text-gray-300 transition-colors"
              aria-label="Close preview"
            >
              <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            {/* Image */}
            <img 
              src={previewImage.src}
              alt={previewImage.alt}
              className="max-w-full max-h-[calc(85vh-80px)] object-contain rounded-sm"
              onClick={(e) => e.stopPropagation()}
            />

            {/* Navigation Controls */}
            <div className="flex items-center justify-center gap-6 mt-6">
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  prevImage();
                }}
                className="text-white hover:text-gray-300 transition-colors p-2"
                aria-label="Previous image"
              >
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
              </button>

              <span className="text-white font-mono text-sm tracking-widest">
                {currentImageIndex + 1} / {allProjects[currentProjectIndex]?.images.length}
              </span>

              <button
                onClick={(e) => {
                  e.stopPropagation();
                  nextImage();
                }}
                className="text-white hover:text-gray-300 transition-colors p-2"
                aria-label="Next image"
              >
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Projects;